import { render, staticRenderFns } from "./MFooter.vue?vue&type=template&id=8368f7b4&scoped=true"
import script from "./MFooter.vue?vue&type=script&lang=js"
export * from "./MFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8368f7b4",
  null
  
)

export default component.exports